var exports = {
  "JC": "UserProfilePopout.module__role___UGlnMU",
  "s$": "UserProfilePopout.module__roleRemoveIcon___UGlnMU",
  "Bx": "UserProfilePopout.module__iconSmall___UGlnMU",
  "bc": "UserProfilePopout.module__profileCustomStatus___UGlnMU",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___UGlnMU",
  "ZB": "UserProfilePopout.module__profileDisplayName___UGlnMU",
  "yn": "UserProfilePopout.module__profileDataWarning___UGlnMU",
  "zF": "UserProfilePopout.module__profilePopoutCard___UGlnMU",
};

module.exports = exports;
